module.exports = __webpack_public_path__ + "static/media/man_with_phone_white.d5f0220b.png";